package one.healthium.insights.ui.components.items

import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.util.fastForEach
import one.healthium.insights.domain.models.ActionModel
import one.healthium.insights.domain.models.ContentEntry
import one.healthium.insights.ui.components.AnchorState
import one.healthium.insights.ui.components.ContentEntryItem
import one.healthium.ui.common.utils.toPaddingValues

@Composable
fun ContentHorizontalList(
    modifier: Modifier = Modifier,
    entry: ContentEntry.HorizontalList,
    anchorState: AnchorState,
    onActionClicked: (ActionModel) -> Unit,
    isMetrics: Boolean,
    actionButton: String? = null,
    onTextActionClicked: () -> Unit = {},
) {
    LazyRow(
        modifier = modifier,
        contentPadding = entry.contentInsets.toPaddingValues(),
    ) {
        entry.content.fastForEach { childEntry ->
            item {
                ContentEntryItem(
                    entry = childEntry,
                    anchorState = anchorState,
                    onActionClicked = onActionClicked,
                    actionButton = actionButton,
                    onTextActionClicked = onTextActionClicked,
                    isMetrics = isMetrics,
                )
            }
        }
    }
}